import { render } from "./settings-signals.vue?vue&type=template&id=272a1c16"
import script from "./settings-signals.vue?vue&type=script&lang=js"
export * from "./settings-signals.vue?vue&type=script&lang=js"

import "./settings-signals.vue?vue&type=style&index=0&id=272a1c16&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__